import React, { Component } from 'react';
import { ClickableCard } from '../Components/Common Components/CommonComponents';
import { Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { ImagePaths } from '../Utility/ImagePaths';
import './Dashboard.css';
import { withTranslation } from 'react-i18next'
import RestAPIService from '../Utility/Services/RestAPIService';
import { Serviceurls } from '../Utility/API/Serviceurls';
import { localClearAll, localGetItem, localSetItem } from '../Utility/Services/CacheProviderService';
import ToastMsg from '../Components/ToastMsg/ToastMsg';
import Loader from '../Components/Loader'
import { CheckAccessFunc } from '../Components/CommonFunctions/CommonFunctions';
import { PermissionsContext } from '../Utility/PermissionContext';

class Dashboard extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      SelectedClinicID: null,
      SelectedClinicName: null,
      SelectedModuleName: null,
      SelectedModuleID: null,
      SelectedModuleIDKey: null,
      ClinicList: [],
      ModuleList: [],
      isLoader:true,
      nurseClinicID: null,
    }
  }
  
  static contextType = PermissionsContext;

  componentDidMount() {
    this.getModulesAPI()
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    }, () => {
      setTimeout(() => {
        this.setState({ isErrorMsg: false, isErrorMsgText: "" })
      }, 2000);
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    }, () => {
      setTimeout(() => {
        this.setState({ successMsg: false, successMsgText: "" })
      }, 2000);
    })
  }

  
  msgClose() {
    this.setState({
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: ''
    })
}

  getModulesAPI = () => {
    try {
      RestAPIService.LoginAuthGetModules(Serviceurls.GET_MODULES_LIST).
        then((response) => {
          if (response.data.status === "success") {
            // Store Modules List in LocalStorage
            if(response.data.data?.length > 0){
              var ModulesList = JSON.stringify(response.data.data);
              localSetItem("ModulesList", ModulesList)
            }
            let clinic = response.data.data
            if(response.data.data?.length === 1 && response.data.data[0].userlinked_module){
              this.modulesData(response.data?.data[0]?.userlinked_module[0]?.moduels,response.data?.data[0]?.userlinked_module[0]?.id)
              localSetItem('state_name', clinic[0]?.state_name || 'Tamil Nadu')
              localSetItem('city_name', clinic[0]?.city_name || "")
              localSetItem("subscription_expired", (clinic[0]?.subscription_expired || false));
              localSetItem("subscription_alert_message", clinic[0]?.subscription_alert_message);
            } else if (response.data.data?.length === 1 && response.data.data[0].data?.length === 1) {
              this.setState({
                SelectedClinicID: response.data?.data[0]?.branch_id,
                SelectedClinicName: response.data?.data[0]?.barnch_name
              }, () => {
                localSetItem('state_name', clinic[0]?.state_name || 'Tamil Nadu')
                localSetItem('city_name', clinic[0]?.city_name || "")
                localSetItem("subscription_expired", (clinic[0]?.subscription_expired || false));
                localSetItem("subscription_alert_message", clinic[0]?.subscription_alert_message);
                this.modulesData(response.data?.data[0]?.data[0]?.moduels, response.data?.data[0]?.data[0]?.id, response.data?.data[0]?.data[0]?.clinic_id)
              })
            } else {
              this.setState({
                ClinicList: response.data.data,
                isLoader: false
              }, () => {
                if (response.data?.data.length === 1){
                  this.setState({
                    SelectedClinicID: response.data?.data[0]?.branch_id,
                    SelectedClinicName:response.data?.data[0]?.barnch_name,
                    ModuleList: response.data?.data[0]?.data,
                  })
                  localSetItem('state_name', clinic[0]?.state_name || 'Tamil Nadu')
                  localSetItem('city_name', clinic[0]?.city_name || "")
                  localSetItem("subscription_expired", (clinic[0]?.subscription_expired || false));
                  localSetItem("subscription_alert_message", clinic[0]?.subscription_alert_message);
                }
              })
            }
          }
        }).catch((error) => {
          if (error?.response?.data?.status === "fail") {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
          setTimeout(()=>{
            localClearAll()
            this.props.history.push({ pathname: '/'})
            }, 2000)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  modulesData = async (ModuleName , ModuleId, nurseClinicID = null) => {
   let module_name = ModuleName === "Standalone Pharmacy" ? "Pharmacy" : ModuleName;
    try {
      this.setState({
        isLoader:true
      }, ()=>{
        RestAPIService.LoginAuthGetModules(Serviceurls.MODULES_DATA_GET + "?linked_modules=" + module_name + "&id=" + ModuleId + "&clinic_id=" + nurseClinicID + "&branch_id=" + this.state.SelectedClinicID).
        then((response) => {
          if (response.data.status === "success") {
            localSetItem("isLoggedIn", true);
            localSetItem("AccessToken", response.data.data.token);
            localSetItem("is_enable_face_data", response?.data?.data?.is_enable_face_data ? true : false);
            localSetItem("BranchId", this.state.SelectedClinicID);
            localSetItem("BranchName", this.state.SelectedClinicName);
            var loginUser = JSON.stringify(response.data.data);
            let smsConfig = JSON.stringify(response.data.data?.sms_config);
            let multiPharmacy = response.data.data?.pharmacy_data?.length > 1 ? true : false
            let multiLab = response.data.data?.laboratory_data?.length > 1 ? true : false
            localSetItem("loggedInUserInfo", loginUser)
            localSetItem("smsConfig", smsConfig)
            localSetItem('auto_log_out_time',response.data.data?.auto_log_out_time ? response.data.data?.auto_log_out_time  : 15)
            localSetItem('auto_fetch_bill_amount_to_payment',response.data.data?.auto_fetch_bill_amount_to_payment ? response.data.data?.auto_fetch_bill_amount_to_payment  : "false")
            localSetItem("show_notification_banner_fo", response.data.data?.show_notification_banner_fo ? response.data.data?.show_notification_banner_fo : false)
            localSetItem('DoctorNotesLock', response.data.data?.unlock_doctor_notes_in_doctor_module)
            localSetItem('is_gst_enabled', response.data.data?.is_gst_enabled ? response.data.data?.is_gst_enabled : false)
            localSetItem('multiPharmacy', multiPharmacy)
            localSetItem('multiLaboratory', multiLab)
            localSetItem('has_abha_service', JSON.stringify(response.data.data?.has_abha_service || false))
            localSetItem('internalStoreEnabled', response?.data?.data?.is_store_enabled ? response?.data?.data?.is_store_enabled : false )
            localSetItem('mainPharmacyEnabled', response?.data?.data?.is_main_pharmacy ? response?.data?.data?.is_main_pharmacy : false )
            localSetItem('hsncode_mandatory_for_billing', JSON.stringify(response.data.data?.hsncode_mandatory_for_billing || false))
            localSetItem('picked_checked_config', JSON.stringify(response.data.data?.picked_checked_config || false))
            localSetItem('po_billvalue_enabled', JSON.stringify(response.data.data?.po_billvalue_enabled || false))
            localSetItem('tpa_insurance_config', JSON.stringify(response?.data?.data?.tpa_insurance_config || false))
            localSetItem('enable_multibilling', JSON.stringify(response.data.data?.enable_multibilling || false))
            localSetItem('enable_safety_deposit', JSON.stringify(response.data.data?.is_safety_deposit_enabled || false))
            localSetItem('safety_deposit_permission', response.data.data?.is_user ? JSON.stringify(response.data.data?.permission_access?.common?.safety_deposit_permission || false) : true)
            localSetItem('show_selective_days_in_prescription', JSON.stringify(response.data.data?.show_selective_days_in_prescription || false))
            localSetItem('op_test_report_payment_check', JSON.stringify(response.data.data?.op_test_report_payment_check || false))
            localSetItem('enable_other_doctor_list', JSON.stringify(response.data.data?.enable_other_doctor_list || false))
            localSetItem('is_single_date_day_end_filter', JSON.stringify(response.data.data?.is_single_date_day_end_filter || false))
            localSetItem('allow_patient_credit_bills', JSON.stringify(response.data.data?.allow_patient_credit_bills))
            localSetItem('ip_order_advance_adjust', JSON.stringify(response.data.data?.enable_ip_order_settlement || false))
            localSetItem('enable_drug_alert', JSON.stringify(response.data.data?.enable_drug_alert || false))
            localSetItem('password_type', response.data.data?.password_type || "strong")

            if (response.data.data?.clinic_id) {
              localSetItem("clinicId", response.data.data?.clinic_id)
            }
            localSetItem('patient_type_config_in_demographics', response.data.data?.patient_type_config_in_demographics || false)
            localSetItem('is_checker', response.data.data?.is_checker || false)
            this.setState({
              isLoader:false
            })
            localSetItem('enable_billing', JSON.stringify(response.data.data?.enable_billing || false))
            localSetItem('enable_billing_transaction', JSON.stringify(response.data.data?.enable_billing_transaction || false))
            if (localGetItem("isNewBilling") === "true") {
              localSetItem('automatic_opthometrist_mapping', JSON.stringify(response.data.data?.automatic_opthometrist_mapping || false))
            } else {
              localSetItem('automatic_opthometrist_mapping', JSON.stringify(true))
            }
            if(response.data.data?.investigation_type_name){
              localSetItem('is_investigation_module', JSON.stringify(response.data.data?.module_name === "Investigation" || false))
              localSetItem('investigation_name', response.data.data?.investigation_type_name)
            }
            if(response.data.data?.module_name === "front_office"){
              this.SetModuleList()
            }
            localSetItem('enable_ai_doctor_notes', JSON.stringify(response.data.data?.enable_ai_doctor_notes ?? false))
            localSetItem('co_payment_option_for_insurance', JSON.stringify(response.data.data?.co_payment_option_for_insurance || false))
            localSetItem('package_access', JSON.stringify(response.data.data?.package_access || []))
            if (response.data.data?.user_package_access) {
              localSetItem('original_package_access', JSON.stringify(response.data.data?.user_package_access))
            }
            localSetItem('org_id', JSON.stringify(response.data.data?.org_id ?? null))
            this.PushHistory(response.data.data.module_name, response.data.data)
            const userInfo = {
              ...response.data.data,
              package_access: response.data.data?.package_access || { modules: [] },
            };
            this.context.updatePermissions(userInfo);
          }
        }).catch((error) => {
          // if (error.response.data.status === "fail") {
          //   this.errorMessage(error.response.data.message)
          // } else {
            this.setState({
              isLoader:false
            }, ()=>{ this.errorMessage(error.message) })
          // }
        })
      })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  SetModuleList() {
    try {
      RestAPIService.getAll(Serviceurls.MODULE_TYPE_LIST_GET).
        then((response) => {
          if (response.data.status === "success") {
            let Module_List = JSON.stringify(response.data.data ? response.data.data : []);
            let Investigation_List = JSON.stringify(response.data.investigation_module_list ? response.data.investigation_module_list : []);
            localSetItem("Mapped_Module_List", Module_List)
            localSetItem("Investigation_List", Investigation_List)
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getDoctorsList() {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME).
        then((response) => {
          if (response.data.status === "success") {
            let doctor_ist = response.data.data ? response.data.data.filter((item) => (item.specialization_active === true)) : []
            let doctorList = JSON.stringify(doctor_ist);
            localSetItem("DoctorsList", doctorList)
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  PushHistory = (Module, Data) => {  
    var UserData = JSON.parse(localGetItem("loggedInUserInfo"))
    const common = UserData?.permission_access?.common || {};
    const abha_available = JSON.parse(localGetItem("has_abha_service"));
    if (Module === "front_office") {
      this.getDoctorsList();
      if (CheckAccessFunc("front_office", "Home", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/OPHome', state: { NewLogin: true } })
      } else if (CheckAccessFunc("front_office", "In Patients", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/IPHome', state: { NewLogin: true } })
      }else if (localGetItem('isNewBilling') === 'true' && Data?.enable_radiotherapy && CheckAccessFunc("front_office", "RT WalkIn", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/RadiotherapyWalkin', state: { NewLogin: true } })
      }else if (localGetItem('isNewBilling') === 'true' && CheckAccessFunc("front_office", "Hospital Billing", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/HospitalBilling', state: { NewLogin: true } })
      }else if (localGetItem('isNewBilling') === 'false' && CheckAccessFunc("front_office", "Billing", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/Billing', state: { NewLogin: true } })
      }else if (CheckAccessFunc("front_office", "Billing Transaction", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/BillingTransaction', state: { NewLogin: true } })
      }else if ((localGetItem('isNewBilling') === 'true') && Data?.enable_credit_settlement) {
        this.props.history.push({ pathname: '/CreditSettlement', state: { NewLogin: true } })
      }else if (CheckAccessFunc("front_office", "Reports", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/FOReports', state: { NewLogin: true } })
      }else if (CheckAccessFunc("front_office", "Settings", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/Settings', state: { NewLogin: true } })
      }else if (Data?.is_user ? common?.can_view_dashboard === true : true) {
        this.props.history.push({ pathname: '/ChartDashboard', state: { NewLogin: true } })
      } else if ((localGetItem('isNewBilling') === 'true') && abha_available && CheckAccessFunc("front_office", "ABDM", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/ABDM', state: { NewLogin: true } })
      }
    } 
    else if (Module === "Laboratory") {
      this.getDoctorsList();
      if (CheckAccessFunc("Laboratory", "Home", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/MainHome', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Laboratory", "Reports", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/LabReports', state: { NewLogin: true } })
      } else if (localGetItem('isNewBilling') === 'true' && CheckAccessFunc("Laboratory", "Lab Billing", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/LabBilling', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Laboratory", "Inventory", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/Inventory', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Laboratory", "Purchase", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/Purchase', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Laboratory", "Settings", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/SettingsHome', state: { NewLogin: true } })
      } else if (UserData?.permission_access?.common?.allow_lab_revert) {
        this.props.history.push({ pathname: '/Revert', state: { NewLogin: true } })
      }
    } else if (Module === "nurse") {
      this.props.history.push({ pathname: '/OPHome', state: { NewLogin: true } })
    } else if (Module === "Pharmacy") {
      let internalStoreEnabled = JSON.parse(localGetItem("internalStoreEnabled"))
      let mainPharmacyEnabled = JSON.parse(localGetItem("mainPharmacyEnabled"))
      let pharmacy_type = UserData?.pharmacy_type === 'Inhouse Pharmacy' ? "Pharmacy" : "Standalone Pharmacy";

      if (CheckAccessFunc(pharmacy_type, "Billing", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/PharmacyBilling', state: { NewLogin: true } })
      } else if (CheckAccessFunc(pharmacy_type, "Billing Transaction", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/PharmacyInvoice', state: { NewLogin: true } })
      } else if (CheckAccessFunc(pharmacy_type, "Inventory", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/PharmacyInventory', state: { NewLogin: true } })
      } else if ((CheckAccessFunc(pharmacy_type, "Purchase", null, null, "Menu")?.viewAccess) && UserData?.is_po_enabled) {
        this.props.history.push({ pathname: '/PharmacyPurchase', state: { NewLogin: true } })
      } else if (CheckAccessFunc(pharmacy_type, "Reports", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/PharmacyReports', state: { NewLogin: true } })
      } else if ((internalStoreEnabled) && (mainPharmacyEnabled) && (CheckAccessFunc(pharmacy_type, "Internal Sales", null, null, "Menu")?.viewAccess)) {
        this.props.history.push({ pathname: '/PharmacyInternalSales', state: { NewLogin: true } })
      } else if (UserData?.pharmacy_type === "Inhouse Pharmacy" && CheckAccessFunc("Pharmacy", "Stock Transfer", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/PharmacyStockTransfer', state: { NewLogin: true } })
      } else if (CheckAccessFunc(pharmacy_type, "Settings", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/PharmacySetting', state: { NewLogin: true } })
      }
    } else if (Module === "sub_location" || Module === "Store Sub Location") {
      if (Data?.sub_location_module === "Front Office") {
        this.props.history.push({ pathname: '/FOStoreTransfer', state: { NewLogin: true } })
      } else if (Data?.sub_location_module === "LAB") {
        this.props.history.push({ pathname: '/LabStoreTransfer', state: { NewLogin: true } })
      } else if (Data?.sub_location_module === "Radiology") {
        this.props.history.push({ pathname: '/RadiologyStoreTransfer', state: { NewLogin: true } })
      } else if (Data?.sub_location_module === "Pharmacy") {
        this.props.history.push({ pathname: '/PharmacyStoreTransfer', state: { NewLogin: true } })
      }  else {
        if (CheckAccessFunc("sub_location", "Home", null, null, "Menu")?.viewAccess) {
          this.props.history.push({ pathname: '/SubLocationBilling', state: { NewLogin: true } })
        } else if (CheckAccessFunc("sub_location", "Reports", null, null, "Menu")?.viewAccess) {
          this.props.history.push({ pathname: '/SubLocationReports', state: { NewLogin: true } })
        } else if (CheckAccessFunc("sub_location", "Stock Transfer", null, null, "Menu")?.viewAccess) {
          this.props.history.push({ pathname: '/SubLocationStockTransfer', state: { NewLogin: true } })
        } else {
          this.props.history.push({ pathname: '/SubLocationBilling', state: { NewLogin: true } })
        }
      }
    } else if (Module === "ot_management") {
      this.props.history.push({ pathname: '/OTHome', state: { NewLogin: true } })
    } else if (Module === "counsellor"){
      this.props.history.push({ pathname: '/Counsellor', state: { NewLogin: true } })
    }else if(Module === 'Doctor' || Module === 'Optometry'){
      this.props.history.push({ pathname: '/DoctorHome', state: {NewLogin : true } })
    }else if(Module === 'Radiology'){
      if (CheckAccessFunc("Radiology", "Home", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/RadiologyHome', state: { NewLogin: true } })
      } else if (localGetItem('isNewBilling') === 'true' && CheckAccessFunc("Radiology", `Radiology Billing`, null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/RadiologyBilling', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Radiology", "Billing Transaction", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/RadiologyBillingTransaction', state: { NewLogin: true } })
      } else if (localGetItem('isNewBilling') === 'true' && CheckAccessFunc("Radiology", "Order", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/RadiologyOrder', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Radiology", "Reports", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/RadiologyReports', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Radiology", "Settings", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/RadiologySettings', state: { NewLogin: true } })
      }
    }else if(Module === 'Investigation' && Data?.investigation_type_name){
      if (CheckAccessFunc(Data?.investigation_type_name, "Home", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: `/${Data?.investigation_type_name}Home`, state: { NewLogin: true } })
      } else if (localGetItem('isNewBilling') === 'true' && CheckAccessFunc(Data?.investigation_type_name, `Investigation Billing`, null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: `/${Data?.investigation_type_name}Billing`, state: { NewLogin: true } })
      } else if (CheckAccessFunc(Data?.investigation_type_name, "Billing Transaction", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: `/${Data?.investigation_type_name}BillingTransaction`, state: { NewLogin: true } })
      } else if (localGetItem('isNewBilling') === 'true' && CheckAccessFunc(Data?.investigation_type_name, "Order", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: `/${Data?.investigation_type_name}Order`, state: { NewLogin: true } })
      } else if (CheckAccessFunc(Data?.investigation_type_name, "Reports", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: `/${Data?.investigation_type_name}Reports`, state: { NewLogin: true } })
      } else if (CheckAccessFunc(Data?.investigation_type_name, "Settings", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: `/${Data?.investigation_type_name}Settings`, state: { NewLogin: true } })
      }
    }else if(Module === 'Organization'){
      this.props.history.push({ pathname: localGetItem("subscription_expired") === "true" ? "/NoAccess" 
        : localGetItem("isNewBilling") === "true" ? '/AdminSettings' 
        : '/AdminDashboard', state: {NewLogin : true } })
    }else if(Module === "canteen"){
      this.props.history.push({ pathname: '/CanteenHome', state: {NewLogin : true } })
    }else if(Module === 'asset_management'){
      this.props.history.push({ pathname: '/AssetHome', state: {NewLogin : true } })
    }else if(Module === 'master_record_department'){
      if (CheckAccessFunc("master_record_department", "Home", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/MrdHome', state: { NewLogin: true } })
      } else if (CheckAccessFunc("master_record_department", "Audit Track", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/MrdAudit', state: { NewLogin: true } })
      } else if (CheckAccessFunc("master_record_department", "Masters", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/MrdMasters', state: { NewLogin: true } })
      }
    }else if(Module === 'JMO'){
      this.props.history.push({ pathname: '/DoctorHome', state: {NewLogin : true } })
    }else if(Module === 'store_module' || Module === "Store"){
      if (CheckAccessFunc("Store", "Purchase", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/StorePurchase', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Store", "Inventory", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/StoreInventory', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Store", "Reports", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/StoreReports', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Store", "Masters", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/StoreSetting', state: { NewLogin: true } })
      } else if (CheckAccessFunc("Store", "Store", null, null, "Menu")?.viewAccess) {
        this.props.history.push({ pathname: '/StoreTransfer', state: { NewLogin: true } })
      }
    }else if(Module === 'Radiotherapy'){
      if(CheckAccessFunc("Radiotherapy", "Stimulation", null, null, "Menu")?.viewAccess){
        this.props.history.push({ pathname: '/RadiotherapyStimulation', state: {NewLogin : true } })
      }else if(CheckAccessFunc("Radiotherapy", "Dosimetrist", null, null, "Menu")?.viewAccess){
        this.props.history.push({ pathname: '/RadiotherapyDosimetrist', state: {NewLogin : true } })
      }else if(CheckAccessFunc("Radiotherapy", "Scheduler", null, null, "Menu")?.viewAccess){
        this.props.history.push({ pathname: '/RadiotherapyScheduler', state: {NewLogin : true } })
      }else if(CheckAccessFunc("Radiotherapy", "Therapist", null, null, "Menu")?.viewAccess){
        this.props.history.push({ pathname: '/RadiotherapyTherapist', state: {NewLogin : true } })
      }else if(CheckAccessFunc("Radiotherapy", "Reports", null, null, "Menu")?.viewAccess){
        this.props.history.push({ pathname: '/RadiotherapyReports', state: {NewLogin : true } })
      }else if(CheckAccessFunc("Radiotherapy", "Settings", null, null, "Menu")?.viewAccess){
        this.props.history.push({ pathname: '/RadiotherapySetting', state: {NewLogin : true } })
      }
    }
  }

  ClinicSelection = (clinic) => {
    this.setState({
      SelectedClinicID: clinic.branch_id,
      SelectedClinicName:clinic.barnch_name,
      ModuleList: clinic.data,
      SelectedModuleName: null,
      SelectedModuleID: null,
      SelectedModuleIDKey: null,
      nurseClinicID: null,
    },() => {
      localSetItem('state_name', clinic?.state_name || 'Tamil Nadu')
      localSetItem('city_name', clinic?.city_name || "")
      localSetItem("subscription_expired", (clinic?.subscription_expired || false));
      localSetItem("subscription_alert_message", clinic?.subscription_alert_message);
    })
  }

  ModuleSelection = (clinic) => {
    this.setState({
      SelectedModuleName: clinic.moduels,
      SelectedModuleID: clinic.id,
      SelectedModuleIDKey: clinic.id + clinic.moduels,
      nurseClinicID: clinic.clinic_id,
    },()=>{
      this.modulesData(this.state.SelectedModuleName , this.state.SelectedModuleID, this.state.nurseClinicID ? this.state.nurseClinicID : '')
    })
  }

  returnIcon(Module){
    switch(Module){
      case "clinic" : return ImagePaths.Hospital.default 
      case "front_office" : return ImagePaths.FrontOfficeLogo.default
      case "Laboratory" : return ImagePaths.Laboratory.default
      case "Pharmacy" : return ImagePaths.PharmacyCard.default
      case "Store Sub Location" : return ImagePaths.PharmacyDashboard.default
      case "sub_location" : return ImagePaths.PharmacyDashboard.default
      case "ot_management" : return ImagePaths.OT.default
      case "counsellor" : return ImagePaths.Counsellor.default
      case 'Doctor' : return ImagePaths.DoctorIcon.default
      case "Radiology" : return ImagePaths.Radiology.default
      case 'master_record_department' : return ImagePaths.MrdIcon.default
      case "Investigation" : return ImagePaths.Investigation.default
      case 'canteen' : return ImagePaths.CanteenModule.default
      case 'asset_management' : return ImagePaths.AssetManagement.default
      case 'Store':
      case 'store_module' : return ImagePaths.StoreModuleIcon.default
      case 'Radiotherapy' : return ImagePaths.Radiotherapy.default
      default : return ImagePaths.FrontOffice.default
    }
  }

  render() {
    const { history } = this.props;
    const { t } = this.props
    return (
      <div className='eMed_ModuleScreen_Wrapper'>
        <div className='eMed_Main_div'>
          <div>
            <Divider textAlign='left' sx={{ margin: '0.7vw' }}>
              <Typography component={'p'}>{t('SelectClinic')}</Typography>
            </Divider>
          </div>
          <div className='eMed_Cards_Wrapper' style={{ maxHeight : '20vh'}}>
            {
              this.state.ClinicList.map((item, index) => (
                <ClickableCard
                  isSelected={item.branch_id === this.state.SelectedClinicID ? true : false}
                  icon={this.returnIcon("clinic")}
                  label={item.barnch_name?.split('_').join(' ')}
                  onClick={this.ClinicSelection.bind(this, item)}
                  alt={item.barnch_name}
                  testID={`${'dash_' + item.barnch_name}`}/>
              ))
            }
          </div>
          {
            this.state.SelectedClinicID != null ?
              <div>
                <Divider textAlign='left' sx={{ margin: '0.7vw' }}>
                  <Typography component={'p'}>{t('SelectModule')}</Typography>
                </Divider>
              </div> : null
          }
          <div className='eMed_Cards_Wrapper'>
            {
              this.state.SelectedClinicID != null ?
                this.state.ModuleList.map((item, index) => (
                  <ClickableCard
                    isSelected={item?.id + item?.moduels === this.state.SelectedModuleIDKey ? true : false}
                    icon={this.returnIcon(item.moduels)}
                    label={item.label}
                    labelTwo={(item.moduels === "sub_location" && item?.module) ? item?.module : null}
                    onClick={this.ModuleSelection.bind(this, item)}
                    alt={item.moduels}
                    testID={`${'dash_' + item.moduels}`} />
                )) : null
            }
          </div>
        </div>
        {/* {
          this.state.SelectedModuleID !== null ?
            <div className='eMed_Proceed_Btn'>
              <Button emed_tid='dash_proceed' sx={{ textTransform: 'capitalize' }} variant='contained'
                onClick={() => {
                  this.modulesData(this.state.SelectedModuleName , this.state.SelectedModuleID, this.state.nurseClinicID ? this.state.nurseClinicID : '')
                }}
              >{t('ProceedBtn')}</Button>
            </div> : null
        } */}
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
         <Loader loaderOpen={this.state.isLoader} />
      </div>
    )
  }
}
export default withTranslation()(Dashboard)